export default __webpack_public_path__ + "static/media/bluePencil.68fbdc6c.svg";